import toast from "react-hot-toast";
import { AppThunk } from "Redux/store";
import { isAxiosResponse } from "Services/index";
import {
  createShapeException,
  customerPricingFromApi,
  deleteShapeException,
  getCustomPricedCustomers,
  getCustomerPricing,
  getPricingHistory,
  getSupplierPricing,
  priceListFromApi,
  putCustomerPricing,
  putSupplierPricing,
  restorePricingHistory,
  shapeExceptionFromApi,
  updateShapeException,
} from "Services/supplier-pricing";
import {
  removeShapeException,
  setCustomLists,
  setCustomerPricing,
  setHistory,
  setPriceList,
  setPricingStatus,
  upsertShapeException,
} from "Redux/features/supplierPricing";
import { CustomerPricing, ShapeException } from "../../utils/supplier-pricing-engine";

const fail = (dispatch: any, message = "שמירה נכשלה, נסו שוב") => {
  dispatch(setPricingStatus("ready"));
  toast.error(message);
};

export const fetchSupplierPricing = (): AppThunk => async (dispatch) => {
  dispatch(setPricingStatus("loading"));
  try {
    const [pricing, lists] = await Promise.all([getSupplierPricing(), getCustomPricedCustomers()]);
    dispatch(setCustomLists(lists.data.map(customerPricingFromApi)));
    dispatch(setPriceList(priceListFromApi(pricing.data)));
  } catch (e) {
    dispatch(setPricingStatus("error"));
  }
};

export const saveSupplierPricing = (): AppThunk => async (dispatch, getState) => {
  const draft = getState().supplierPricing.draft;
  if (!draft) return;
  dispatch(setPricingStatus("saving"));
  try {
    const response = await putSupplierPricing(draft);
    if (isAxiosResponse(response)) {
      dispatch(setPriceList(priceListFromApi(response.data)));
      toast.success("המחירון נשמר");
    }
  } catch (e) {
    fail(dispatch);
  }
};

export const fetchPricingHistory = (): AppThunk => async (dispatch) => {
  const response = await getPricingHistory();
  if (isAxiosResponse(response)) dispatch(setHistory(response.data));
};

export const restorePricingChange = (id: number): AppThunk => async (dispatch) => {
  const response = await restorePricingHistory(id);
  if (isAxiosResponse(response)) {
    dispatch(setPriceList(priceListFromApi(response.data)));
    dispatch(fetchPricingHistory());
  }
};

export const saveShapeExceptionThunk = (e: ShapeException, next?: () => void): AppThunk => async (dispatch) => {
  try {
    const response = e.id ? await updateShapeException(e.id, e) : await createShapeException(e);
    if (isAxiosResponse(response)) {
      dispatch(upsertShapeException(shapeExceptionFromApi(response.data)));
      next && next();
    }
  } catch (err) {
    toast.error("לא ניתן לשמור את החריג");
  }
};

export const deleteShapeExceptionThunk = (id: number): AppThunk => async (dispatch) => {
  await deleteShapeException(id);
  dispatch(removeShapeException(id));
};

export const fetchCustomerPricing = (customerId: number): AppThunk => async (dispatch) => {
  const response = await getCustomerPricing(customerId);
  if (isAxiosResponse(response)) dispatch(setCustomerPricing(customerPricingFromApi(response.data)));
};

export const saveCustomerPricing = (customerId: number, data: CustomerPricing, next?: () => void): AppThunk => async (dispatch) => {
  try {
    const response = await putCustomerPricing(customerId, data);
    if (isAxiosResponse(response)) {
      dispatch(setCustomerPricing(customerPricingFromApi(response.data)));
      toast.success("מחירון הלקוח נשמר");
      next && next();
    }
  } catch (e) {
    toast.error("שמירה נכשלה, נסו שוב");
  }
};
